// src/utils/appointments/reschedule.ts
import { Appointment } from "../../types/appointments/AppointmentTypes";
import { dayjs } from "../time";
import type { UserUuid } from "../../types/identity";

export interface RescheduleMove {
	start: Date;
	end: Date;
	// The column the drop landed in; null in the week views, which have none.
	toColumnId: UserUuid | null;
	action: "move" | "resize";
}

export interface RescheduleTarget {
	start: Date;
	end: Date;
	practitionerId: UserUuid;
}

// Mirrors the drawer's Save gate exactly — Cliniko owns the times of an appointment it created.
export const canRescheduleAppointment = (appointment?: Pick<Appointment, "created_in_cliniko"> | null): boolean =>
	Boolean(appointment) && !appointment?.created_in_cliniko;

export const rescheduleTarget = (appointment: Appointment, move: RescheduleMove): RescheduleTarget => {
	const booked = dayjs(appointment.end_time).diff(dayjs(appointment.start_time));

	return {
		start: move.start,
		// A move keeps the booked duration whatever the grid reports; only a resize changes it.
		end: move.action === "resize" ? move.end : dayjs(move.start).add(booked, "millisecond").toDate(),
		// The week views have no column, so a drop there cannot change practitioner.
		practitionerId: move.toColumnId ?? appointment.practitioner_id,
	};
};

export const isSameSlot = (appointment: Appointment, target: RescheduleTarget): boolean =>
	dayjs(appointment.start_time).isSame(target.start) &&
	dayjs(appointment.end_time).isSame(target.end) &&
	appointment.practitioner_id === target.practitionerId;
